// extracted by mini-css-extract-plugin
export var bold = "_r6-0";